import { render } from "./CaseDetail.vue?vue&type=template&id=d39939e4&scoped=true&ts=true"
import script from "./CaseDetail.vue?vue&type=script&lang=ts"
export * from "./CaseDetail.vue?vue&type=script&lang=ts"

import "./CaseDetail.vue?vue&type=style&index=0&id=d39939e4&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39939e4"]])

export default __exports__